export const theme = {
  colors: {
    textDark: '#000',
    textLight: '#EDF3FC',
    white: '#fff',
    
    mainBg: '#c3d0e3',
    secondaryBg: '#edf3fc',
    accentBg: '#6c8fc4',

    accent: 'orange',
    
    muted: '#f6f6f6',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
//   fonts: {
//     body: 'system-ui, sans-serif',
//     heading: 'system-ui, sans-serif',
//     monospace: 'Menlo, monospace',
//   },
  fontSizes: {
    xs: 12,
    s: 14,
    m: 16,
    l: 32,
    xl: 64,
  },
  fontWeights: {
      normal: 400,
      preBold: 600,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: '0',
    small: '2px',
    normal: '4px',
    round: '50%',
  },
};